import { accessCriteria } from '../util/authorization/index';

const DOCUMENT_TITLE = 'Mortgage Tax';

export const MtgRoutes = [
  {
    path: '/mtg',
    name: 'MortgageTax',
    meta: {
      title: DOCUMENT_TITLE,
    },
    component: () => import('../views/MortgageTax.vue'),
    children: [
      {
        path: 'transactions',
        name: 'Mortgage Tax - Transactions',
        meta: {
          title: DOCUMENT_TITLE,
        },
        component: () => import('../views/Mtg/Transactions.vue'),
      },
      {
        path: 'browse',
        name: 'Mortgage Tax - Browse',
        meta: {
          title: DOCUMENT_TITLE,
        },
        component: () => import('../views/Mtg/browse/browse.vue'),
        children: [
          {
            path: 'receivedof',
            name: 'Mortgage Tax - Received Of',
            meta: {
              title: DOCUMENT_TITLE,
            },
            component: () => import('../views/common/Whom.vue'),
          },
          {
            path: 'exemptmortgagees',
            name: 'Mortgage Tax - Exempt Mortgagees',
            meta: {
              title: DOCUMENT_TITLE,
            },
            component: () => import('../views/common/ExemptMortgagees.vue'),
          },
        ],
      },
      {
        path: 'reports',
        name: 'Mortgage Tax - Reports',
        meta: {
          title: DOCUMENT_TITLE,
        },
        component: () => import('../views/Mtg/Reports.vue'),
      },
      {
        path: 'utils',
        name: 'Mortgage Tax - Utils',
        meta: {
          title: DOCUMENT_TITLE,
        },
        component: () => import('../views/Mtg/utils/MtgUtils.vue'),
        children: [
          {
            path: 'createfiscalyear',
            name: 'Mortgage Tax - Create Fiscal Year',
            meta: {
              title: DOCUMENT_TITLE,
            },
            component: () => import('../views/Mtg/utils/MortgageCreateFiscalYear.vue'),
          },
        ],
      },
    ],
  },
];

MtgRoutes.forEach((element, index) => {
  MtgRoutes[index].beforeEnter = async (to, from, next) => {
    await accessCriteria(['MtgAdministration', 'MtgUser'], next);
  };
});

export default MtgRoutes;
